import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { max } from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      transform: 'translate(34px, 20px) scale(1);',
    },
    '&.Mui-focused .MuiInputLabel-outlined': {
      color: 'purple',
    },
  },
  inputRoot: {
    color: 'purple',
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
      paddingLeft: 26,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'green',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'purple',
    },
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '1.5rem',
      fontSize: '1rem',
    },
    paddingLeft: '1rem',
    fontSize: '1rem',
    color: '#fff',
    alignItems: 'center',
    display: 'flex',
    position: 'sticky', // 상단에 고정
    top: 0, // 페이지 상단에 고정
    zIndex: 1000, // 다른 요소보다 위에 배치
    height: '2rem',
    backgroundColor: '#101012',
  },
  cardGrid: {
    columnGap: '5px',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '-0.4rem',
  },
  card: {
    display: 'inline-block',
    flex: '0 0 auto',
    border: '0.1rem solid #2d2e2f',
    backgroundColor: '#161616',
    padding: '.7rem',
    paddingBottom: '.5rem',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    width: '95%', // 너비를 95%로 설정
    margin: '0 auto', // 가로 가운데 정렬
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
    transition: 'transform 0.3s ease-in-out',
    maxHeight: '4rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '20rem',
      width: '20rem',
      maxHeight: '4rem',
      marginLeft: '1rem',
      marginRight: '0',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
    },
    [theme.breakpoints.down(476)]: {
      fontSize: '0.75rem',
      padding: '.4rem',
      paddingBottom: '.3rem',
      width: '100%',
      marginLeft: '0',
    },
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.02)',
    },
  },
  cardSecondColumn: {
    flex: 'vertical',
  },
  cardLabel: {
    flex: 1,
    marginLeft: '0.3rem',
    marginTop: '-0.7rem',
    display: '-webkit-box',
    fontSize: '0.85rem',
    flexWrap: 'wrap',
    height: 'auto',
    maxHeight: '2rem',
    overflow: 'hidden',
    color: '#fff',
    overflowWrap: 'anywhere',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2, // 최대 줄 수를 2로 설정
    WebkitBoxOrient: 'vertical',
    '@media (max-width: 600px)': {
      fontSize: '0.8rem',
    },
  },

  cardLastMessage: {
    display: '-webkit-box',
    marginLeft: '2.69rem',
    marginTop: '-0.6rem',
    marginBottom: '0.6rem',
    flex: 1,
    fontSize: '0.8rem',
    color: '#c6c8cc',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    lineHeight: '1rem',
    maxHeight: '2.4rem',
    [theme.breakpoints.down(476)]: {
      fontSize: '0.6rem',
      lineHeight: '0.8rem',
      maxHeight: '2rem',
      marginBottom: '0',
      marginTop: '0',
    },
    '@media (max-width: 960px)': {
      fontSize: '0.65rem',
      lineHeight: '1rem',
      marginTop: '0',
      marginBottom: '0',
    },
  },

  cardUpdatedAt: {
    fontSize: '0.7rem',
    color: '#d3d3d3',
    marginLeft: '0.3rem',
    marginBottom: '0.8rem',
    [theme.breakpoints.down(476)]: {
      fontSize: '0.6rem',
    },
  },
  pagination: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#ffffff',
    margin: '1rem 0',
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('m')]: {
      marginLeft: '50rem',
    },
    [theme.breakpoints.down(1134)]: {
      width: '6.3rem',
    },
    backgroundColor: '#CAFF73',
    padding: '0.6rem 0 0 0',
    margin: '.3rem 0 .5rem 0',
    width: '7.0rem',
    fontSize: '1.1rem',
    borderRadius: '0.2rem',
    textAlign: 'center',
    cursor: 'pointer',
    height: '2.5rem',
    verticalTextAlign: 'center',
  },
  coverImg: {
    userSelect: 'none',
    width: '2rem',
    height: '2rem',
    display: 'inline-block',
    flexShrink: '1',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
    borderRadius: '50%',
    border: '0.07rem solid #808080',
    marginRight: '0.5rem',
    marginTop: '0.5rem',
    marginBottom: '-0.2rem',
  },
  coverImgPlaceholder: {
    userSelect: 'none',
    width: '2rem',
    height: '2rem',
    display: 'inline-block',
    flexShrink: '1',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
    borderRadius: '50%',
    border: '0.07rem solid #808080',
    marginRight: '0.5rem',
    marginTop: '0.5rem',
    marginBottom: '-0.2rem',
  },
  infiniteScroll: {
    display: 'flex',
    // overflowX: 'scroll',
    flexDirection: 'column',
    scrollbarWidth: 'none', // For Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // For Chrome, Safari, and Opera
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
  scrollContainer: {
    // overflowX: 'hidden',  // Hide scrollbar but allow scrolling
    overflowY: 'auto',
    heigth: '100%',
    paddingBottom: '10px', // Optional: Add some padding to prevent content clipping
  },
}));

export { useStyles };
